import { createSignal, createEffect } from "solid-js";
import { exitPromptState, setExitPromptState } from "../overlayState";
import FocusableButton from "./FocusableButton";
import { Row } from "@solidtv/solid/primitives";

export default function ExitPrompt(props: any) {
  let container: any;
  let cancelButton: any;

  createEffect(() => {
    if (exitPromptState()) {
      // Explicitly focus the cancel button
      if (cancelButton) {
        cancelButton.setFocus();
      }
    }
  });

  const close = () => {
    setExitPromptState(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  const exitApp = () => {
    // Exit app for Tizen (Samsung)
    // @ts-ignore
    if (typeof tizen !== 'undefined' && tizen.application) {
      // @ts-ignore
      tizen.application.getCurrentApplication().exit();
    }
    // Exit app for WebOS (LG) or generic browsers
    else {
      window.close();
    }
  };

  return (
    <view
      ref={container}
      alpha={exitPromptState() ? 1 : 0}
      transition={{ alpha: { duration: 300, easing: "ease-out" } }}
      display={exitPromptState() ? "flex" : "none"}
      position="absolute"
      width={1920}
      height={1080}
      zIndex={100}
      color={0x000000cc}
      onBack={close}
      onBackspace={close}
      onEscape={close}
    >
      <view
        x={510}
        y={315}
        width={900}
        height={450}
        color={0x2b2b31ff} // Slightly lighter dark gray for better contrast
        borderRadius={40}
      >
        <text
          x={450}
          mountX={0.5}
          y={100}
          fontSize={52}
          fontWeight="bold"
          fontFamily="Roboto"
          color={0xffffffff}
        >
          Do you want to exit Chek+?
        </text>

        <Row x={130} y={250} gap={80} scroll="none">
          <FocusableButton ref={cancelButton} autofocus onEnter={close}>
            Cancel
          </FocusableButton>
          <FocusableButton onEnter={exitApp}>
            Exit
          </FocusableButton>
        </Row>
      </view>
    </view>
  );
}
